module.exports = __webpack_public_path__ + "static/media/atencao.04a21472.svg";